import { createSlice } from "@reduxjs/toolkit";
import { collection, addDoc, getFirestore } from "firebase/firestore";
import app from "./firebaseinit";

const videosDb = "videos";
const db = getFirestore(app);
/* eslint-disable no-param-reassign */
export const videosSlice = createSlice({
  name: "videos",
  initialState: {
    videos: [],
    uservideos: [],
  },
  reducers: {
    getUsersVideos: (state, action) => {
      state.videos = [];
      state.videos = action.payload;
    },
    getUserVideos: (state, action) => {
      state.videos = [];
      state.uservideos = action.payload;
    },
    uploadUserVideos: (state, action) => {
      console.log(state);
      const videos = [...state.uservideos, action.payload];
      try {
        addDoc(collection(db, videosDb), action.payload);
        state.uservideos = videos;
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    },
  }
});
export const { getUsersVideos, getUserVideos, uploadUserVideos } = videosSlice.actions;

export default videosSlice.reducer;
